module.exports = __webpack_public_path__ + "static/images/bg_get_result.1defad2.png";